import Activity from 'assets/icons/jobs/Activity'
import { useRef, useState } from 'react'
import { MdOutlineNotStarted, MdOutlineStopCircle } from 'react-icons/md'
import { useOnClickOutSide } from 'tools/hooks/click-outSide-handler'
import { JobStatusIcons } from './constant'
import useFetchJobs from './hook/useFetchJob'
import { exportExcelJob } from './utils/exportExcel'
import { RiDeleteBin5Line } from 'react-icons/ri'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import { addEditDataAPI, deleteDataAPI } from 'services/CRUDServices'
import { ClipLoader } from 'react-spinners'
import { getDay } from 'tools/functions/Methods'

function Jobs() {
  const [toggle, setToggle] = useState(false)
  const { jobs, loadingJob, fetchData } = useFetchJobs(toggle)
  const [selectedIndex, setIndex] = useState<number>(-1)
  const WrapperRef = useRef(null)
  const [loadingStates, setLoadingStates] = useState<Record<string, boolean>>(
    {}
  )
  useOnClickOutSide(WrapperRef, toggle, setToggle)

  async function stopJob(jobId: string) {
    setLoadingStates((prev) => ({ ...prev, [`stop_${jobId}`]: true }))
    try {
      await addEditDataAPI(
        `/consignment-api/jobs/user-jobs/${jobId}/stop`,
        'put',
        undefined
      )
    } catch (error) {
      console.error('Error stopping job:', error)
    } finally {
      setIndex(-1)
      await fetchData()
      setLoadingStates((prev) => ({ ...prev, [`stop_${jobId}`]: false }))
    }
  }

  async function startJob(jobId: string) {
    setLoadingStates((prev) => ({ ...prev, [`start_${jobId}`]: true }))
    try {
      await addEditDataAPI(
        `/consignment-api/jobs/user-jobs/${jobId}/start`,
        'put',
        undefined
      )
    } catch (error) {
      console.error('Error starting job:', error)
    } finally {
      await fetchData()
      setIndex(-1)
      setLoadingStates((prev) => ({ ...prev, [`start_${jobId}`]: false }))
    }
  }

  async function deleteJob(jobId: string) {
    setLoadingStates((prev) => ({ ...prev, [`delete_${jobId}`]: true }))
    try {
      await deleteDataAPI(`/consignment-api/jobs/user-jobs/${jobId}`)
      setToggle((prev) => !prev)
    } catch (error) {
      console.error('Error deleting job:', error)
    } finally {
      setIndex(-1)
      setLoadingStates((prev) => ({ ...prev, [`delete_${jobId}`]: false }))
    }
  }

  return (
    <div className='relative flex justify-center' ref={WrapperRef}>
      {/* <button onClick={exportExcel}>export excel</button> */}
      <button onClick={() => setToggle(!toggle)}>
        <div className=' flex gap-2'>
          <Activity />
        </div>
      </button>
      {toggle ? (
        <div className='ToggleContainer  h-80 overflow-y-auto  flex  flex-col gap-y-2 !top-8 -right-36 w-60    p-2'>
          {jobs.length !== 0 ? (
            jobs.map(({ job, status, fileResultId, progress, id,lastTry }, index) => (
              <div key={index} className=' flex items-start gap-2'>
                {loadingJob && selectedIndex === index ? (
                  Array.from({ length: 2 }).map((_, index) => (
                    <div
                      key={index}
                      className='flex items-start gap-2 animate-pulse'
                    >
                      <div className='w-6 h-6 rounded-full bg-gray-200'></div>
                      <div className='flex-1 space-y-2'>
                        <div className='h-4 bg-gray-200 rounded w-3/4'></div>
                        <div className='w-full bg-gray-200 rounded-full h-2'></div>
                        <div className='flex justify-between items-center'>
                          <div className='h-3 bg-gray-200 rounded w-1/3'></div>
                          <div className='flex gap-1'>
                            <div className='w-5 h-5 bg-gray-200 rounded-full'></div>
                            <div className='w-5 h-5 bg-gray-200 rounded-full'></div>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <div className=' w-6 h-6'>
                      {fileResultId ? (
                        <button
                          onClick={(e) => exportExcelJob(e, fileResultId)}
                        >
                          {JobStatusIcons['EXCEL']}
                        </button>
                      ) : (
                        JobStatusIcons[status?.key]
                      )}
                    </div>
                    <div className=''>
                      <p className='  font-semibold text-xs'>{job?.value} {getDay(lastTry,lastTry.hour+":"+lastTry.minute)}</p>
                      {status.key === 'IN_PROGRESS' && (
                        <div className='w-full mt-2 bg-gray-200 rounded-full h-2 overflow-hidden'>
                          <div
                            className=' bg-tomato h-full transition-all duration-300'
                            style={{ width: `${+progress || 0}%` }}
                          ></div>
                        </div>
                      )}
                      <div className='flex justify-between items-center mb-2'>
                        <p className=' text-xs text-gray-500'>
                          {' '}
                          {status?.value}
                        </p>

                        <div className='flex gap-1 items-center'>
                          {['STOPPED'].includes(status.key) && (
                            <SimpleButton
                              text=''
                              icon={
                                loadingStates[`start_${id}`] ? (
                                  <ClipLoader size={20} />
                                ) : (
                                  <MdOutlineNotStarted size={20} />
                                )
                              }
                              className='p-0 gap-0'
                              handelClick={() => {
                                setIndex(index)
                                startJob(id)
                              }}
                            />
                          )}
                          {['IN_PROGRESS'].includes(status.key) && (
                            <SimpleButton
                              text=''
                              icon={
                                selectedIndex === index &&
                                loadingStates[`stop_${id}`] ? (
                                  <ClipLoader size={20} />
                                ) : (
                                  <MdOutlineStopCircle size={20} />
                                )
                              }
                              className='p-0 gap-0'
                              handelClick={() => {
                                stopJob(id)
                                setIndex(index)
                              }}
                            />
                          )}

                          {!['IN_PROGRESS'].includes(status.key) && (
                            <SimpleButton
                              text=''
                              icon={
                                loadingStates[`delete_${id}`] ? (
                                  <ClipLoader size={20} />
                                ) : (
                                  <RiDeleteBin5Line size={20} />
                                )
                              }
                              className='p-0 gap-0'
                              handelClick={() => {
                                setIndex(index)
                                deleteJob(id)
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>
                  </>
                )}
              </div>
            ))
          ) : (
            <>هیچ موردی یافت نشد</>
          )}
        </div>
      ) : null}
    </div>
  )
}

export default Jobs
